import React, { useEffect } from 'react';
import posthog from 'posthog-js';
import { Link, useSearchParams } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './App.css';
import './Success.css';

const Success: React.FC = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    posthog.capture('purchase_completed', { stripe_session_id: sessionId });
    window.scrollTo(0, 0);
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="App">
      <Header showNav={true} />
      <section className="success-section">
        <div className="container">
          <div className="success-content text-center">
            <div className="success-icon">
              <svg
                width="80"
                height="80"
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <circle
                  cx="40"
                  cy="40"
                  r="40"
                  fill="#10B981"
                />
                <path
                  d="M25 40L35 50L55 30"
                  stroke="white"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <h1 className="success-title">Thank You!</h1>
            <p className="success-subtitle">
              Your ColorCache purchase was successful.
            </p>

            <div className="success-message">
              <div className="email-note">
                <p>
                  You'll receive a confirmation email from <strong>team@codec422.com</strong> with your license key and download instructions.
                </p>
                <p className="spam-warning">
                  If you don't see it in your inbox within a few minutes, please check your <strong>spam</strong> or <strong>promotions</strong> folder.
                </p>
              </div>
            </div>

            <div className="success-actions">
              <Link
                to="/"
                className="btn btn-primary"
                onClick={scrollToTop}>
                Back to Home
              </Link>
              <p className="support-note">
                Need help? Contact us at <a href="mailto:team@codec422.com" className="support-link">team@codec422.com</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Success;
